"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlHelper = void 0;
var ApplicationActions_1 = require("../../actions/ApplicationActions");
var queryString = null;
var UrlHelper = (function () {
    function UrlHelper() {
    }
    UrlHelper.getQueryString = function () {
        if (!queryString) {
            queryString = ApplicationActions_1.getParams(window.location.search);
        }
        return queryString;
    };
    UrlHelper.buildQueryString = function (obj) {
        if (!obj) {
            return '';
        }
        return Object.keys(obj)
            .map(function (k) { return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]); })
            .join('&');
    };
    return UrlHelper;
}());
exports.UrlHelper = UrlHelper;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/UrlHelper.ts
// module id = 53
// module chunks = 0 2